<style lang="scss">
li.tab {
  list-style: none;
  position: relative;
  display: block;
  white-space: nowrap;

  &.tab__active {
    border-top: 3px solid transparent;
    border-top-color: #348ee3;
    margin-bottom: -1px;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;

    > a {
      background-color: #fff;
      color: #242a30;
      border: 1px solid #e3e3e3;
      border-bottom-color: transparent;
    }
  }

  &.tab__disabled {
    > a {
      color: #ccc;
      cursor: not-allowed;
    }
  }

  > a {
    position: relative;
    display: block;
    padding: 10px 15px;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: #e3e3e3;
    color: #6e7179;
    line-height: 20px;
    text-decoration: none;
  }

  &.tab__vertical {
    > a {
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: #e3e3e3;
    }

    &.tab__active {
      border-left: 3px solid transparent;
      border-left-color: #348ee3;
      border-top: none;
      margin-bottom: 0px;
      margin-right: -1px;
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;

      > a {
        border-right-color: transparent;
      }
    }
  }
}
</style>

<template>
  <li class="tab" :class="[directionClass, activeClass, disableClass]">
    <a href="#" @click.prevent="selectTab">
      <slot></slot>
    </a>
  </li>
</template>

<script>
export default {
  name: 'Tab',
  inject: ['elProp'],
  props: {
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    activeClass() {
      return {
        tab__active: this.isActive
      }
    },
    disableClass() {
      return {
        tab__disabled: this.disabled
      }
    },
    directionClass() {
      return {
        tab__vertical: this.elProp.vertical
      }
    }
  },
  methods: {
    selectTab() {
      if (this.disabled) return

      let th = this

      this.isActive = true
      this.$set(this.elProp, 'activeTab', this)
    }
  }
}
</script>
